import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import Icon from 'wonderbly-components/lib/Icon';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import PaymentIcons from '../PaymentIcons';
import PayPal from './PayPal';
import Amazon from './Amazon';
import Accordion from '../Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import DiscountForm from '../CartSummary/DiscountForm';
import RichText from '../Prismic/RichText';
import MentionMe from '../MentionMe';

import './Checkout.scss';

const isMethodSupported = (id, paymentMethods = []) => paymentMethods.some(method => method.id === id);

const Checkout = props => {
  return (
    <React.Fragment>
      <div className="cart-summary-checkout">
        {!props.hidePaymentIcons &&
          <Col className="cart-summary-payment-icons">
            <div className="cart-summary-payment-icons__label">
              {props.paymentMethodsLabel || 'We accept:'}
            </div>
            <PaymentIcons exclusionList={props.exclusionList} />
          </Col>
        }
        <div className="padded-wrapper">
          <Button
            onClick={props.handleCheckout}
            className="checkout-button"
            href={props.checkoutUrl}
            colour="green"
            fullWidth
            raised>
            <Icon icon="lock" />
            {` ${props.checkoutCta}`}
          </Button>
          <div className="quick-checkout">
            {props.quickCheckoutLabel &&
              <p className="quick-checkout-title">{props.quickCheckoutLabel}</p>
            }
            <Row colsToRowsOn="fablet-down">
              {!props.hidePaypalButton && isMethodSupported('paypal_checkout', props.paymentMethods) && (
                <Col>
                  <PayPal paymentMethods={props.paymentMethods} href={props.paypalUrl} />
                </Col>
              )}
              {isMethodSupported('amazon_pay', props.paymentMethods) && (
                <Col>
                  <Amazon paymentMethods={props.paymentMethods} autoLogout />
                </Col>
              )}
            </Row>
          </div>
        </div>
        <Accordion>
          <AccordionItem
            isExpanded={props.isAccordionExpanded}
            label={
              <RichText
                fields={props.description}
                className="discount-form-description"
              />
            }>
            <DiscountForm
              description={props.description}
              cta={props.cta}
              placeholder={props.placeholder}
            />
          </AccordionItem>
        </Accordion>
        <MentionMe
          type="refereefind"
          situation="checkout"
          country={props.country}
          implementation="link"
          id="mmWrapper"
        />
      </div>
    </React.Fragment>
  );
};

Checkout.propTypes = {
  checkoutUrl: PropTypes.string.isRequired,
  checkoutCta: PropTypes.string.isRequired,
  quickCheckoutLabel: PropTypes.string,
  paymentMethods: PropTypes.array.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  description: PropTypes.array.isRequired,
  cta: PropTypes.string.isRequired,
  paypalUrl: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  country: PropTypes.object,
  exclusionList: PropTypes.arrayOf(PropTypes.string),
  hidePaypalButton: PropTypes.bool,
  hidePaymentIcons: PropTypes.bool,
  isAccordionExpanded: PropTypes.bool,
  paymentMethodsLabel: PropTypes.string
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/Checkout.js